<template>
  <div>
    <a-form
      :form="form"
      @submit="addSettingRoles"
    >
      <a-form-item
        label="角色名称"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-input
          v-decorator="[
            'name',
            {rules: [{ required: true, message: '请填写角色名称!' }]}
          ]"
          placeholder="输入角色名称"
        />
      </a-form-item>
      <a-form-item
        label="角色描述"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-textarea
          v-decorator="[
            'remark',
            {rules: [{ required: true, message: '请填写角色描述!' }]}
          ]"
          placeholder="输入角色描述"
          class="describe-textarea"
          :rows="4"/>
      </a-form-item>
      <a-form-item
        label="状态"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-radio-group v-decorator="['status', {initialValue: '1'}]">
          <a-radio value="1">
            开启
          </a-radio>
          <a-radio value="0">
            禁用
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        :wrapper-col="{ span: 12, offset: 4 }"
        v-if="JSON.stringify(record) === '{}'"
      >
        <a-button
          type="primary"
          html-type="submit"
        >
          提交
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { createRole, updateRole } from '@/api/manage'
import pick from 'lodash.pick'

export default {
  props: {
    record: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      // 添加角色form表单
      formLayout: 'horizontal',
      form: this.$form.createForm(this)
    }
  },
  mounted () {
    this.show()
  },
  methods: {
    show () {
      this.loadEditInfo(this.record)
    },
    // 角色添加 submit
    addSettingRoles (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.type == 1) {
            return createRole(values).then((res) => {
              this.$message.success(res.msg)
              this.$emit('ok', values)
            }).catch((err) => this.requestFailed(err))
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            values.id = this.record.id
            return updateRole(values).then((res) => {
              this.$message.success(res.msg)
              this.$emit('ok', values)
            }).catch((err) => this.requestFailed(err))
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },

    requestFailed (err) {
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).msg || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    loadEditInfo (data) {
      new Promise((resolve) => {
        resolve()
      }).then(() => {
        const formData = pick(data, ['name', 'remark', 'status'])
        formData.status = formData.status !== undefined ? formData.status.toString() : '1'
        this.form.setFieldsValue(formData)
      })
    },
    resetField () {
      this.form.resetFields()
    }
  }
}
</script>

<style>

</style>
